import React from 'react';
import { Box, Typography, Grid, IconButton, Divider } from '@mui/material';
import { Email, Facebook, SmartDisplay, Language } from '@mui/icons-material';
import SvgIcon from '@mui/material/SvgIcon';

function TikTokIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16.5 3a3.5 3.5 0 0 1-3.5-3h-3v15.5a2.5 2.5 0 1 1-2.5-2.5 2.5 2.5 0 0 1 1.5.5V9.64a5 5 0 1 0 4 4.86V5.65A7.5 7.5 0 0 0 16.5 7V3z" />
    </SvgIcon>
  );
}

export default function IntroduceSection() {
  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 5 }}>
      <Box sx={{ width: '100%', maxWidth: '1344px', px: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>

        {/* Về dự án */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              display: 'inline-block',
              bgcolor: '#8a0000',
              color: 'white',
              px: 2,
              py: 0.5,
              borderRadius: '16px',
              fontWeight: 'bold',
              mb: 2
            }}
          >
            Về dự án
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'justify' }}>
            Tiếng vọng Sử Việt - ChroniCall là một hành trình kết nối quá khứ và hiện tại qua ba phần:
            <strong> Lược sử</strong>, <strong>Chiến ký</strong> và <strong>Hồi âm</strong>. Lược sử dẫn lối người đọc trở về với
            những dấu mốc huy hoàng của dân tộc, những thời khắc làm nên vận mệnh non sông. Chiến ký lưu giữ những câu chuyện chân thực,
            những hình ảnh sống động được nhóm trực tiếp phỏng vấn và ghi lại từ chính lời kể của các cựu chiến binh – những trang sử sống
            chưa từng được công bố, mang lại góc nhìn mới mẻ và sâu sắc về một thời lửa đạn đã qua. Hồi âm là điểm sáng của dự án, nơi người
            truy cập có thể gửi lời tri ân, chia sẻ cảm xúc hoặc kể lại câu chuyện của bản thân và người thân. Sự tương tác hai chiều này tạo
            nên cầu nối gắn kết bền chặt giữa các cựu chiến binh và thế hệ trẻ hôm nay. Mỗi câu chuyện được kể là một nhịp cầu nối liền quá khứ
            hào hùng với tương lai rực rỡ mà cha ông đã dày công vun đắp.
          </Typography>
        </Box>

        <Divider />

        {/* Mục tiêu hướng đến */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              display: 'inline-block',
              bgcolor: '#8a0000',
              color: 'white',
              px: 2,
              py: 0.5,
              borderRadius: '16px',
              fontWeight: 'bold',
              mb: 2
            }}
          >
            Mục tiêu hướng đến
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'justify', mb: 2 }}>
            Tiếng vọng Sử Việt – ChroniCall được tạo nên nhằm đánh thức ký ức, thắp sáng niềm tự hào và kết nối nhịp đập của tất cả thế hệ người Việt.
          </Typography>
          <ul style={{ paddingLeft: '20px', marginTop: 0 }}>
            <li><strong>Lưu giữ hồn sử Việt:</strong> Mỗi câu chuyện, mỗi bức ảnh, mỗi lời kể được trân trọng số hóa, để những hồi ức hào hùng không bao giờ bị phủ mờ bởi thời gian.</li>
            <li><strong>Kết nối quá khứ và hiện tại:</strong> Để những cựu chiến binh có thể tự mình kể lại những tháng năm lửa đạn, và thế hệ trẻ được lắng nghe bằng cả trái tim.</li>
            <li><strong>Lan tỏa tinh thần tri ân:</strong> Gửi lời cảm ơn bằng những câu chữ, hình ảnh, hành động – để sự hy sinh của cha ông trở thành sức mạnh nuôi dưỡng tình yêu đất nước hôm nay.</li>
            <li><strong>Tạo không gian lịch sử sống động:</strong> Nơi quá khứ và hiện tại giao hòa, nơi mọi người có thể cùng sẻ chia ký ức, cảm xúc và trách nhiệm với non sông đất Việt.</li>
          </ul>
          <Typography variant="body1" sx={{ textAlign: 'justify', mt: 1 }}>
            Chúng tôi tin rằng, một dân tộc sẽ thật sự mạnh mẽ để vươn mình khi ký ức của quá khứ được chảy mãi trong mạch sống của hiện tại và soi sáng con đường kiến tạo tương lai.
          </Typography>
        </Box>

        <Divider />

        {/* Liên hệ với chúng tôi */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              display: 'inline-block',
              bgcolor: '#8a0000',
              color: 'white',
              px: 2,
              py: 0.5,
              borderRadius: '16px',
              fontWeight: 'bold',
              mb: 2
            }}
          >
            Liên hệ với chúng tôi
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <IconButton color="primary" href="https://tiengvongsuviet.com" target="_blank">
                <Language />
              </IconButton>
              <Typography variant="body2">tiengvongsuviet.com</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <IconButton color="primary" href="https://facebook.com" target="_blank">
                <Facebook />
              </IconButton>
              <Typography variant="body2">Tiếng Vọng Sử Việt</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <IconButton color="error" href="mailto:tiengvongsuviet@gmail.com">
                <Email />
              </IconButton>
              <Typography variant="body2">tiengvongsuviet@gmail.com</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <IconButton
                color="secondary"
                href="https://tiktok.com/@tiengvongsuviet"
                target="_blank"
              >
                <TikTokIcon />
              </IconButton>
              <Typography variant="body2">@tiengvongsuviet</Typography>
            </Grid>
          </Grid>
        </Box>

      </Box>
    </Box>
  );
}
